import type { ReactNode } from 'react';
import { memo } from 'react';
import type { BoxProps } from '@mui/material';
// @mui
import { Box } from '@mui/material';

//
import { StyledRootScrollbar, StyledScrollbar } from './styles';

// ----------------------------------------------------------------------

export type ScrollbarProps = {
    children?: ReactNode;
    sx?: BoxProps['sx'];
};

function Scrollbar({ children, sx, ...other }: ScrollbarProps) {
    const userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent;

    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

    if (isMobile) {
        return (
            <Box sx={ { overflowX: 'auto', ...sx } } { ...other }>
                { children }
            </Box>
        );
    }

    return (
        <StyledRootScrollbar>
            <StyledScrollbar timeout={ 500 } clickOnTrack={ false } sx={ sx } { ...other }>
                { children }
            </StyledScrollbar>
        </StyledRootScrollbar>
    );
}

export default memo(Scrollbar);
